import { extendTheme, type ThemeConfig } from '@chakra-ui/react';
import { mode } from '@chakra-ui/theme-tools';

const colors = {
  brand: {
    50: '#e8f1f9',
    100: '#c5dbef',
    200: '#9fc3e3',
    300: '#79abd7',
    400: '#5c97cc',
    500: '#447eb7',
    600: '#3b6fa3',
    700: '#305b87',
    800: '#25476b',
    900: '#173050',
  },
};

const styles = {
  global: (props: any) => ({
    '::-webkit-scrollbar': {
      width: '10px',
      height: '7px',
    },
    '::-webkit-scrollbar-track': {
      backgroundColor: mode('gray.200', 'gray.900')(props),
      borderRadius: '6px',
    },
    '::-webkit-scrollbar-thumb': {
      backgroundColor: mode('brand.200', 'brand.200')(props),
      borderRadius: '6px',
    },
    '::-webkit-scrollbar-thumb:hover': {
      backgroundColor: mode('brand.500', 'brand.500')(props),
    },
    '.ProseMirror': {
      '.ProseMirror-focused': {
        outline: 'none',
        border: 'none',
      },
    },
    label: {
      touchAction: 'none',
    },
  }),
};

const config: ThemeConfig = {
  initialColorMode: 'light',
  useSystemColorMode: false,
};

const theme = extendTheme({ config, colors, styles });

export default theme;
